import { Maybe } from '@atlassian/cssxp-typescommon';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { generatedTypesSxp } from '@css-xp/graphtypes';
import { AxiosError } from 'axios';
import { CCPVaidationError } from '../ccp-client/ccp';

const client = createAxiosClient({ baseURL: '/api/1/quotes' }, ServiceProxyMap.PPC_BFF);

interface QuoteOrderRequestPayload {
  source: string;
  orderId: string;
  quote: {
    id: string;
    version: Maybe<number> | undefined;
  };
  metadata?: Maybe<generatedTypesSxp.QuoteMetaData> | undefined;
}

interface QuoteUpdateRequestPayload {
  lineItems: generatedTypesSxp.QuoteLineItem[];
  id: string;
  invoiceGroupId?: string;
}

export const placeQuoteOrderV2 = async (
  orderPayload: QuoteOrderRequestPayload,
  transactionAccountId: string,
  invoiceGroupId: string,
  isBillingProfileChanged: boolean
) => {
  const payload = {
    orderPayload,
    transactionAccountId,
    invoiceGroupId,
    isBillingProfileChanged,
  };

  try {
    const response = await client.post('/place-order', payload, {
      validateStatus: (status) => status === 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (err) {
    if (err instanceof AxiosError && err?.response?.data?.payload) {
      const { title, items, code } = err.response.data.payload;
      throw new CCPVaidationError(title, items, code);
    }
    throw err;
  }
};

export const updateOpenQuote = async (updatePayload: QuoteUpdateRequestPayload, transactionAccountId: string) => {
  const payload = {
    updatePayload,
    transactionAccountId,
  };

  try {
    const response = await client.put('/updateOpenQuote', payload, {
      validateStatus: (status) => status === 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (err) {
    if (err instanceof AxiosError && err?.response?.data?.payload) {
      const { title, items, code } = err.response.data.payload;
      throw new CCPVaidationError(title, items, code);
    }
    throw err;
  }
};
